// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"1328bfb0","76":"8a472605","88":"ba9493fa","145":"f6165daa","461":"895da5c5","704":"27b80190"}[chunkId] + ".chunk.css";
};